import React, { useState } from "react";
import { Menu, Dropdown, Modal, Tooltip } from "antd";
import { Link } from "react-router-dom";
import LoadingSkeleton from "../loading-sekeleton/LoadingSkeleton";
import { COLORS, Typo } from "../../../../../layout/theme";
import {
	ActionButton,
	AntdTable,
	ColorState,
	Container,
	Section,
	StateContainer,
	TableContainer,
} from "./styles";
import { BsInfoCircle, BsThreeDotsVertical } from "react-icons/bs";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import { MdComputer } from "react-icons/md";
import { BiMobile } from "react-icons/bi";
import { FiPhoneCall } from "react-icons/fi";
import { FaHeadset } from "react-icons/fa";

import moment from "moment";
import { AiOutlineAudit } from "react-icons/ai";
import { CONSTANTS } from "../../../../../../utils/constants";
import { GiArtificialIntelligence } from "react-icons/gi";

export default function OrdersTable({ data, loading, clientId }) {
	const [key, setKey] = useState(null);
	const [modalInfo, setModalInfo] = useState(null);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const showModal = (r) => {
		setIsModalOpen(true);
		setModalInfo(r);
	};
	const handleOk = () => {
		setIsModalOpen(false);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/marketOrders/${key}`}>
							<Typo type="secondary">Ver detalle</Typo>
						</Link>
					),
				},
			]}
		/>
	);

	const columns = [
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						# ORDEN
					</div>
				);
			},
			dataIndex: "orderNumId",
			render: (f, r) => (
				<Section>
					<Container cursor="pointer" onMouseOver={() => setKey(r?.id)}>
						<Link to={`/admin/marketOrders/${key}`}>
							<Typo type="primary" fontWeight={600} fontSize={14}>
								{f}
							</Typo>
						</Link>
						{r.orderHasMegaDistributor > 0 && (
							<Tooltip
								title={`Productos a Distribuidor: ${r.orderHasMegaDistributor}`}
							>
								<BsInfoCircle color={COLORS.Secondary} />
							</Tooltip>
						)}
					</Container>
					<Typo type="mediumGrey" fontWeight={500} fontSize={13}>
						{moment(r.created).format("DD/MM/YYYY")}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						USUARIO
					</div>
				);
			},
			dataIndex: "typeOfSale",
			render: (f, r) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo
						type="darkGrey"
						fontWeight={600}
						fontSize={14}
						onClick={() => showModal(r)}
						style={{ cursor: "pointer" }}
					>
						{r.typeOfSale === "IASELL" ? (
							<GiArtificialIntelligence />
						) : r.typeOfSale === "WEB" && r.sellerClientName !== "OneMarket" ? (
							<MdComputer />
						) : r.typeOfSale === "WEBSELLER" ? (
							<FaHeadset />
						) : f === "EXPO" ? (
							<AiOutlineAudit />
						) : r.typeOfSale === "MOBILE" ? (
							<>
								<BiMobile />{" "}
								<Typo type="darkGrey" fontWeight={600} fontSize={12}>
									App
								</Typo>
							</>
						) : (
							<FiPhoneCall />
						)}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						LABORATORIO
					</div>
				);
			},
			dataIndex: "laboratoryOrderName",
			render: (f, r) => (
				<Container>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{f}
					</Typo>
					{r.orderLaboratories > 1 && (
						<Tooltip title={`Laboratorios distintos: ${r.orderLaboratories}`}>
							<BsInfoCircle color={COLORS.Secondary} />
						</Tooltip>
					)}
				</Container>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						DROGUERIA
					</div>
				);
			},
			dataIndex: "distributorName",
			render: (f) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						PUNTO DE VENTA
					</div>
				);
			},
			dataIndex: "pointOfSaleName",
			render: (f) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ITEMS
					</div>
				);
			},
			dataIndex: "qtyItems",
			render: (f) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{f}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "end",
						}}
					>
						TOTAL
					</div>
				);
			},
			width: 250,
			dataIndex: "total",
			render: (f, record) => (
				<Section style={{ alignItems: "end" }}>
					<Typo type="primary" fontWeight={700} fontSize={15}>
						$ {numberWithDotAndCommas(parseFloat(f))}
					</Typo>
					<Typo type="success" fontWeight={500} fontSize={13}>
						{record.discount === 0
							? ``
							: `Desc.: $ ${numberWithDotAndCommas(parseFloat(record.discount))} `}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ESTADO
					</div>
				);
			},
			width: 180,
			dataIndex: "orderState",
			render: (fila, record) => {
				let colorBackground = COLORS.LightGrey3;
				let colorText = COLORS.MediumGrey;

				switch (fila) {
					case "PROCESADA":
						colorBackground = COLORS.LightDefault;
						colorText = COLORS.Default;
						break;
					case "Pending":
						colorBackground = COLORS.LightWarning;
						colorText = COLORS.Warning;
						break;
					case "Active":
						colorBackground = COLORS.LightSecondary;
						colorText = COLORS.Secondary;
						break;
					case "Sended":
						colorBackground = COLORS.LightSuccess;
						colorText = COLORS.Success;
						break;
					case "Canceled":
						colorBackground = COLORS.LightDanger;
						colorText = COLORS.Danger;
						break;

					default:
						break;
				}

				return (
					<StateContainer>
						<ColorState colorBackground={colorBackground}>
							{record.orderSubState ? (
								<Typo fontWeight={600} fontSize={14}>
									{record.orderSubState === "PROCESADA" && "Procesada"}
								</Typo>
							) : (
								<Typo
									fontWeight={600}
									fontSize={14}
									style={{ color: colorText }}
								>
									{fila === "Pending" && "Pendiente"}
									{fila === "Active" && "Activa"}
									{fila === "Sended" && "Enviada"}
									{fila === "Canceled" && "Cancelada"}
								</Typo>
							)}
						</ColorState>
					</StateContainer>
				);
			},
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 10,
			render: (f, r, i) => (
				<>
					<Dropdown overlay={menu} placement="bottomRight">
						<ActionButton key={`${f}`} onMouseOver={() => setKey(f)}>
							<BsThreeDotsVertical />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	if (!data) return <LoadingSkeleton />;

	return (
		<TableContainer>
			<AntdTable
				columns={columns}
				dataSource={data}
				loading={loading}
				pagination={false}
			/>
			{modalInfo && (
				<Modal
					title={
						<Typo type="primary" level={4}>
							Usuario de la compra
						</Typo>
					}
					open={isModalOpen}
					onOk={handleOk}
					onCancel={handleCancel}
				>
					<p>
						Nombre:{" "}
						{modalInfo.iaSell
							? "Agente IA"
							: modalInfo.sellerFirstName + " " + modalInfo.sellerLastName}
					</p>
					<p>Mail: {modalInfo.iaSell ? "-" : modalInfo.sellerEmail}</p>
					<p>
						Usuario de:{" "}
						{modalInfo.typeOfSale === "WEB"
							? modalInfo.sellerClientName + " - Usuario Web"
							: modalInfo.typeOfSale === "WEBSELLER"
								? modalInfo.sellerClientName + " - Vendedor Web"
								: modalInfo.typeOfSale === "MOBILE"
									? modalInfo.sellerClientName + " - Usuario Mobile"
									: modalInfo.typeOfSale === "IASELL"
										? "One Transfer IA"
										: "Usuario One Market"}
					</p>
					{modalInfo.typeOfSale === "IASELL" && (
						<Link to={`/admin/agentOrders/${clientId}`}>
							Ir a listado Agente
						</Link>
					)}
				</Modal>
			)}
		</TableContainer>
	);
}
